<template>
    <rkm-overlay>
        <rkm-layout-body title="Lançamento de coleta">
            <template v-slot:actions>
                <rkm-button
                    @click="$refs.Form.openModalAgendamento()"
                    color="info"
                    :disabled="!verificarPermissao('store-exame-laboratorial-agendamento-exame')"
                    :title="verificarPermissao('store-exame-laboratorial-agendamento-exame')
                            ? 'Agendar exame'
                            : 'O usuário logado não tem permissão para agendar.'"
                >
                    Agendamento de exame
                </rkm-button>
                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>
            <rkm-layout-content v-if="loaded">
                <Form
                    :data="{ initials, form, model, additionals }"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import Form from '@/components/exame-laboratorial/lancamento-coleta/Form'

import { mapActions } from 'vuex'
import { repository, error, permissao, object, data } from '@/mixins'

export default {
    components: { Form },
    created() {

        this.repositories = {
            lancamento: this.getConectaSusRepository('exameLaboratorial.lancamentoColeta')
        }

        this.load()
    },
    data: () => ({
        loaded: false,
        initials: {
            model: {}
        },
        form: {},
        model: {},
        additionals: {},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.lancamento.create()
                .then(({ data }) => {

                    data.model.periodo.start = this.getDateObject(data.model.periodo.start)
                    data.model.periodo.end = this.getDateObject(data.model.periodo.end)

                    this.initials.model = Object.freeze(this.clone(data.model))

                    this.form = data.form
                    this.model = data.model

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [repository, error, permissao, object, data]
}
</script>